import request from '@/utils/request'

// 退出
export function logOut(data) {
  return request({
    url: '/auth/logout',
    method: 'get',
    params: data
  })
}

// 验证码
export function getCodeImg() {
  return request({
    url: '/auth/verify',
    method: 'get',
    responseType: 'arraybuffer'
  })
}

